/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, ActionButton, LargeCloseIcon, Pressable } from '@components/atoms'
import { motion } from 'framer-motion'

import { grey } from '@mui/material/colors'

interface PropsType {
	show: boolean
	isFullModal?: boolean
	width?: number

	// header
	title: string
	renderTitle?: JSX.Element

	// event
	onCloseModal?: () => void

	children?: JSX.Element
}

export const SideModal = (props: PropsType) => {
	// state
	const [showModal, setShowModal] = React.useState<boolean>(props.show)

	// variables
	const isFullModal: boolean = props.isFullModal ?? false
	const width: number = props.width ? props.width : 20

	React.useEffect(() => {
		setShowModal(props.show)
	}, [props.show])

	const onCloseModal = () => {
		setShowModal(false)
		if (props.onCloseModal !== undefined) {
			props.onCloseModal()
		}
	}

	return (
		<motion.div
			css={style}
			className={isFullModal ? 'fullModal' : ''}
			initial={{ opacity: 0, width: 0 }}
			animate={showModal ? { opacity: 1, width: `${width}rem` } : { width: 0 }}
			exit={{ opacity: 0, width: 0 }}
			transition={{ duration: 0.2 }}
		>
			<View className="sideModalWrapper">
				<View className="sideModalOuter">
					{isFullModal ? (
						<View className="fullModalHeaderView">
							<View className="fullModalCloseButtonView">
								<Pressable className="fullModalCloseButton" onClick={onCloseModal}>
									<LargeCloseIcon strokeColor="white" size={60} />
								</Pressable>
							</View>

							<View className="fullModalTitleView">
								<Text category="c1" className="fullModailTitle">
									{props.title}
								</Text>
							</View>
						</View>
					) : (
						<View className="headerView">
							{props.renderTitle ? (
								props.renderTitle
							) : (
								<Text category="s1">{props.title}</Text>
							)}
							<ActionButton
								className="closeButton"
								tooltip="닫기"
								onClick={onCloseModal}
								iconName="close-thick"
								iconTextColor={grey[700]}
							/>
						</View>
					)}
				</View>
				<View className="sideContentView">{props.children}</View>
			</View>
		</motion.div>
	)
}

const style = css({
	position: 'absolute',
	zIndex: 9,
	width: '20rem',
	top: '-0.5rem',
	right: '-0.5rem',
	background: '#FFF',
	boxShadow: `-2px 0px 10px ${grey[400]}`,
	overflow: 'hidden',

	'&.fullModal': {
		height: '100%',
		top: 0,
		right: 0,
		padding: '0.5rem',
		boxSizing: 'border-box',

		'.sideModalWrapper': {
			height: '100%',

			'.fullModalHeaderView': {
				position: 'relative',
				height: '8rem',
				borderBottom: '1px solid',

				'.fullModalCloseButtonView': {
					position: 'absolute',
					top: '-0.5rem',
					left: '-0.5rem',

					'.fullModalCloseButton': {
						margin: 0,
						padding: 0,
					},
				},

				'.fullModalTitleView': {
					position: 'absolute',
					bottom: 0,
					left: 0,

					'.fullModailTitle': {
						marginBottom: '0.3rem',
					},
				},
			},
		},

		'.sideContentView': {
			height: 'calc(100% - 8rem)',
		},
	},

	'.sideModalOuter': {
		'.headerView': {
			position: 'relative',
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			width: '100%',
			height: '3rem',
			padding: '0 0.7rem',
			borderBottom: '1px solid',
			borderColor: grey[100],

			'.closeButton': {
				position: 'absolute',
				right: '0.5rem',
			},
		},
	},

	'.sideContentView': {
		position: 'relative',
		height: 'calc(100% - 5.8rem)',
		overflow: 'auto',
	},

	'@media (max-width:900px)': {
		width: '20rem',
		height: '100%',

		'&.fullModal': {
			height: '100%',
			top: 0,
			right: 0,
			padding: '0.5rem',
			boxSizing: 'border-box',

			'.fullModalHeaderView': {
				position: 'relative',
				height: '8rem',
				borderBottom: '1px solid',

				'.fullModalCloseButtonView': {
					position: 'absolute',
					top: '-0.5rem',
					left: '-0.5rem',

					'.fullModalCloseButton': {
						margin: 0,
						padding: 0,
					},
				},

				'.fullModalTitleView': {
					position: 'absolute',
					bottom: 0,
					left: 0,

					'.fullModailTitle': {
						marginBottom: '0.3rem',
					},
				},
			},
		},
	},
})
